/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

/**
 * Debounces events.
 * @param fn Function to execute.
 * @returns Debouncing function.
 */
export const debounceRaF = (fn: Function): Function => {
  let timeout: any;
  return function (...args: string[]): void {
    if (timeout) {
      window.cancelAnimationFrame(timeout);
    }
    timeout = window.requestAnimationFrame(() => {
      fn.apply(this, args);
    });
  };
};

/**
 * Helper for lighterweight classNames package, clsx.
 * @returns A string.
 */
function toVal(mix: any): string {
  let k, y, str = '';
  if (mix) {
    if (typeof mix === 'object') {
      if (Array.isArray(mix)) {
        for (k = 0; k < mix.length; k++) {
          if (mix[k] && (y = toVal(mix[k]))) {
            str && (str += ' ');
            str += y;
          }
        }
      } else {
        for (k in mix) {
          if (mix[k] && (y = toVal(k))) {
            str && (str += ' ');
            str += y;
          }
        }
      }
    } else if (typeof mix !== 'boolean' && !mix.call) {
      str && (str += ' ');
      str += mix;
    }
  }
  return str;
}

/**
 * Equivalent to lighterweight classNames package, clsx.
 * @returns The className string.
 */
export function classNames(...args: any): string {
  let i = 0, x, str = '';
  while (i < args.length) {
    x = toVal(args[i++]);
    if (x) {
      str && (str += ' ');
      str += x;
    }
  }
  return str;
}
